module.exports = __webpack_public_path__ + "img/symbol_4.e97a7589.png";